module.exports = __webpack_public_path__ + "img/shareimg2.33b58fd8.png";